import { useState } from 'react';
import { useKeycloak } from '@react-keycloak/web';

export const useMediaPlayer = (initialMessage = "Выберите видео для просмотра") => {
    const { keycloak } = useKeycloak();
    const [selectedMediaId, setSelectedMediaId] = useState(null);
    const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
    const [playerMessage, setPlayerMessage] = useState(initialMessage);

    const handleMediaSelect = (mediaPoint) => {
        if (!mediaPoint) {
            setSelectedMediaId(null);
            setCurrentVideoUrl(null);
            setPlayerMessage(initialMessage);
            return;
        }

        const mediaServerUrl = process.env.REACT_APP_MEDIA_SERVER_URL || 'http://localhost:8289';

        // if (keycloak && keycloak.token) {
            const videoUrl = `${mediaServerUrl}/live/${mediaPoint.id}.m3u8?token=${keycloak.token}`;
            setCurrentVideoUrl(videoUrl);
            setPlayerMessage(null);
        // } else {
        //     console.error("Keycloak token is not available. User needs to log in.");
        //     setCurrentVideoUrl(null);
        //     setPlayerMessage("Войдите в систему для просмотра");
        // }
        setSelectedMediaId(mediaPoint.id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return {
        selectedMediaId,
        currentVideoUrl,
        playerMessage,
        handleMediaSelect,
    };
};